import Icon from 'components/Icon/Icon.component';
import PromoSvgIconComponent from 'images/icons/bonus_promo.svg?react';
import PokerstarsAppIcon from 'images/icons/pokerstars/navbar-app-icon.svg?react';
import React from 'react';
import { SecondaryLinksProps } from '../ExpandedNavbar.type';
import {
  ExternalNavLink,
  SecondaryLinksWrapper,
} from '../style/ExpandedNavbar.style';

const SecondaryLinks: React.FC<SecondaryLinksProps> = function SecondaryLinks({
  navbarContent,
}) {
  return (
    <SecondaryLinksWrapper>
      <li>
        <ExternalNavLink
          href={navbarContent.linkPromo}
          target="_self"
          noReferrer={false}
        >
          <Icon svgIconComponent={PromoSvgIconComponent} marginRight={'6px'} />
          <span>{navbarContent.labelPromo}</span>
        </ExternalNavLink>
      </li>
      {navbarContent.linkLoyalty != null && (
        <li>
          <ExternalNavLink
            href={navbarContent.linkLoyalty}
            target="_self"
            noReferrer={false}
          >
            <Icon svgIconComponent={PokerstarsAppIcon} marginRight={'6px'} />
            <span> {navbarContent.labelLoyalty}</span>
          </ExternalNavLink>
        </li>
      )}
    </SecondaryLinksWrapper>
  );
};

export default SecondaryLinks;
